import { bindActionCreators, } from 'redux';
import { connect, } from 'react-redux';
import * as Signup from '../../actions/Signup';
import * as Signin from '../../actions/Signin';
import * as DashboardActions from '../../actions/DashboardActions';
import * as ParcelAction from '../../actions/ParcelAction';
import * as ShipmentAction from '../../actions/ShipmentAction';
import * as AddressAction from '../../actions/AddressAction';
import * as CheckoutActions from '../../actions/CheckoutActions';
import * as SettingsAction from '../../actions/SettingsAction';
import * as Cms from '../../actions/CmsActions';
import * as CartAction from '../../actions/CartAction';

import Dashboard from '../Dashboard/Dashboard';

function mapStateToProps(state){
  return{
    login: state.signin,
    register: state.signup,
    auth: state.auth,
    customerInfo: state.dashboard,
    parcelInfo:state.parcel,
    shipmentInfo:state.shipment,
    customerAddress: state.address,
    customerCheckout : state.checkout,
    settings : state.settings,
    cms: state.cms,
    cart: state.cart
  }
}
function mapDispachToProps(dispatch){
  return bindActionCreators(
    Object.assign(
      {},
      Signin, 
      Signup, 
      DashboardActions,
      ParcelAction,
      ShipmentAction,
      AddressAction,
      CheckoutActions,
      Cms,
      SettingsAction,
      CartAction
    )
    , dispatch);
}

const DashboardConnection = connect(mapStateToProps, mapDispachToProps)(Dashboard);

export default DashboardConnection;



/** WEBPACK FOOTER **
 ** ./src/components/DashboardFiles/DashboardConnection.js
 **/